import '@webtrader/core/storage';
import '@webtrader/core/i18n';

import BigNumber from 'bignumber.js';

BigNumber.config({
  FORMAT: {
    prefix: '',
    decimalSeparator: '.',
    groupSeparator: ',',
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: ' ',
    fractionGroupSize: 0,
    suffix: ''
  },
  ROUNDING_MODE: BigNumber.ROUND_HALF_UP
});
